import createDLPPiDataLoaderFn from './data.pi';
import DestinationLandingPagePI from './page.pi';

export { DestinationLandingPagePI };
export { createDLPPiDataLoaderFn };
